import React from 'react';
import { TrendingUp } from 'lucide-react';

const colorStyles = {
  green: {
    iconBg: 'bg-gradient-to-br from-emerald-500 to-teal-600 text-white shadow-glow-emerald',
    badgeBg: 'bg-emerald-50 text-emerald-700 border-emerald-200/60',
    accentDot: 'bg-emerald-500'
  },
  emerald: {
    iconBg: 'bg-gradient-to-br from-teal-500 to-cyan-600 text-white shadow-glow-teal',
    badgeBg: 'bg-teal-50 text-teal-700 border-teal-200/60',
    accentDot: 'bg-teal-500'
  },
  teal: {
    iconBg: 'bg-gradient-to-br from-indigo-500 to-violet-600 text-white shadow-glow-indigo',
    badgeBg: 'bg-indigo-50 text-indigo-700 border-indigo-200/60',
    accentDot: 'bg-indigo-500'
  },
  amber: {
    iconBg: 'bg-gradient-to-br from-amber-500 to-orange-600 text-white',
    badgeBg: 'bg-amber-50 text-amber-700 border-amber-200/60',
    accentDot: 'bg-amber-500'
  },
};

const StatCard = ({ title, value, icon: Icon, color = 'green', isLive = false, trend = '+12.5%' }) => {
  const c = colorStyles[color] || colorStyles.green;

  return (
    <div className="group relative bg-white/90 backdrop-blur-xl rounded-2xl border border-slate-200/80 p-5 shadow-[0_4px_20px_-2px_rgba(0,0,0,0.03)] hover:shadow-[0_12px_30px_-4px_rgba(0,0,0,0.08)] hover:-translate-y-1 transition-all duration-300 flex flex-col justify-between overflow-hidden">
      {/* Decorative ambient background blur */}
      <div className="absolute -right-6 -bottom-6 w-24 h-24 rounded-full bg-slate-100/50 group-hover:scale-150 transition-transform duration-500 pointer-events-none" />

      {/* Header: Title & Gradient Icon */}
      <div className="flex items-center justify-between z-10">
        <p className="text-[11px] font-extrabold text-slate-400 uppercase tracking-wider">{title}</p>
        <div className={`p-2.5 rounded-xl ${c.iconBg} group-hover:scale-110 transition-transform duration-300`}>
          <Icon className="w-4 h-4" />
        </div>
      </div>

      {/* Metric Value & Visual Trend */}
      <div className="mt-4 mb-2 z-10">
        <div className="flex items-baseline justify-between">
          <h3 className="text-3xl font-extrabold text-slate-900 font-display tracking-tight leading-none group-hover:text-emerald-700 transition-colors">
            {value}
          </h3>
        </div>
      </div>

      {/* Footer Indicator */}
      <div className="pt-2 border-t border-slate-100/80 flex items-center justify-between z-10 text-xs">
        {isLive ? (
          <div className="flex items-center gap-2">
            <span className="relative flex h-2.5 w-2.5">
              <span className="animate-radar absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500" />
            </span>
            <span className="text-[11px] font-extrabold text-emerald-700 tracking-wide uppercase">Socket.io Live</span>
          </div>
        ) : (
          <div className="flex items-center gap-1.5 text-[11px] font-semibold text-emerald-600 bg-emerald-50/80 px-2 py-0.5 rounded-md border border-emerald-200/50">
            <TrendingUp className="w-3 h-3" />
            <span>{trend}</span>
          </div>
        )}

        <span className="text-[10px] text-slate-400 font-medium">Updated live</span>
      </div>
    </div>
  );
};

export default StatCard;

